import Immutable from 'immutable';
import {
  all,
  call,
  put,
  takeLatest,
  takeEvery,
  fork,
  select,
} from 'redux-saga/effects';

import * as actions from './actions';
import * as API from './api';
import { getCourseProgressLesson, isExamLocked } from './selectors';

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export function* loadCourseAssemblage({ payload }) {
  const { classId } = payload;

  yield put(actions.loadCourseAssemblage.request(classId));
  const response = yield call(API.loadCourseAssemblage, classId);
  if (response.ok) {
    yield put(actions.loadCourseAssemblage.success(classId, response.body));
  } else {
    yield put(
      actions.loadCourseAssemblage.failure(classId, response.failureReason)
    );
  }
}

export function* loadCourseProgress({ payload }) {
  const { userId, classId } = payload;

  yield put(actions.loadCourseProgress.request(classId));
  const response = yield call(API.loadUserCourseProgress, userId, classId);
  if (response.ok) {
    yield put(actions.loadCourseProgress.success(classId, response.body));
  } else {
    yield put(
      actions.loadCourseProgress.failure(classId, response.failureReason)
    );
  }
}

export function* loadClassProgress({ payload }) {
  const { classId } = payload;

  yield put(actions.loadClassProgress.request(classId));
  const response = yield call(API.loadSchoolClassProgress, classId);
  if (response.ok) {
    yield put(actions.loadClassProgress.success(classId, response.body));
  } else {
    yield put(
      actions.loadClassProgress.failure(classId, response.failureReason)
    );
  }
}

export function* setExamLocked({ payload }) {
  const { classId, examId, isLocked } = payload;
  const currentIsLocked = yield select(
    isExamLocked,
    classId,
    examId,
    !!'isTeacher'
  );
  if (isLocked == currentIsLocked) {
    yield put(
      actions.setExamLocked.success(classId, examId, isLocked, Immutable.Map())
    );
    return;
  }

  yield put(actions.setExamLocked.request(classId, examId, isLocked));
  const response = yield call(API.setExamLocked, classId, examId, isLocked);
  if (response.ok) {
    yield put(
      actions.setExamLocked.success(classId, examId, isLocked, response.body)
    );
  } else {
    yield put(
      actions.setExamLocked.failure(
        classId,
        examId,
        isLocked,
        response.failureReason
      )
    );
  }
}

export function* setLessonSelfRating({ payload }) {
  const { classId, lessonId, rating } = payload;
  const courseLessonProgress = yield select(
    getCourseProgressLesson,
    classId,
    lessonId
  );
  const currentRating = courseLessonProgress.get('self_rating');

  yield put(actions.setLessonSelfRating.request(classId, lessonId, rating));
  const response = yield call(API.setLessonSelfRating, lessonId, rating);

  if (response.ok) {
    yield put(actions.setLessonSelfRating.success(classId, lessonId));
  } else {
    yield put(
      actions.setLessonSelfRating.failure(classId, lessonId, currentRating)
    );
  }
}

export function* loadClassDetail({ payload }) {
  const { classId } = payload;

  yield put(actions.loadClassDetail.request(classId));
  const response = yield call(API.loadClassDetail, classId);
  if (response.ok) {
    yield put(actions.loadClassDetail.success(classId, response.body));
  } else {
    yield put(actions.loadClassDetail.failure(classId, response.failureReason));
  }
}

// TBC: remove/rename me?
export default function* studyplannerSagas() {
  yield all([
    fork(function* () {
      yield takeLatest(
        actions.LOAD_COURSE_ASSEMBLAGE_SIGNAL,
        loadCourseAssemblage
      );
    }),
    fork(function* () {
      yield takeLatest(actions.LOAD_COURSE_PROGRESS_SIGNAL, loadCourseProgress);
    }),
    fork(function* () {
      yield takeLatest(actions.LOAD_CLASS_PROGRESS_SIGNAL, loadClassProgress);
    }),
    fork(function* () {
      yield takeEvery(actions.SET_EXAM_LOCKED_SIGNAL, setExamLocked);
    }),
    fork(function* () {
      yield takeEvery(
        actions.SET_LESSON_SELF_RATING_SIGNAL,
        setLessonSelfRating
      );
    }),
    fork(function* () {
      yield takeEvery(actions.LOAD_CLASS_DETAIL_SIGNAL, loadClassDetail);
    }),
  ]);
}
